import React, { useState, useEffect } from 'react';

const InstallPrompt = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showInstallPrompt, setShowInstallPrompt] = useState(false);
    const [isIOSPromptVisible, setIsIOSPromptVisible] = useState(false);

    useEffect(() => {
        // بررسی وضعیت نصب قبلی (Standalone Mode)
        // این بررسی برای iOS (ویژگی navigator.standalone) و بقیه پلتفرم‌ها (matchMedia) کار می‌کند.
        const isStandalone =
            window.matchMedia('(display-mode: standalone)').matches ||
            window.navigator.standalone === true;

        // اگر اپلیکیشن قبلاً نصب شده است، هیچ پیامی نشان نده
        if (isStandalone) {
            return;
        }

        // تشخیص سیستم‌عامل iOS
        const isIOS = () => {
            const userAgent = window.navigator.userAgent.toLowerCase();
            return /iphone|ipad|ipod/.test(userAgent);
        };

        if (isIOS()) {
            // در iOS چون beforeinstallprompt نداریم، پیام راهنما را مستقیماً نشان می‌دهیم
            setIsIOSPromptVisible(true);
        } else {
            // برای اندروید و دسکتاپ به رویداد beforeinstallprompt گوش می‌دهیم
            const handleBeforeInstallPrompt = (e) => {
                e.preventDefault();
                setDeferredPrompt(e);
                setShowInstallPrompt(true);
            };

            window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

            // وقتی کاربر اپلیکیشن را نصب کرد این رویداد اجرا می‌شود
            window.addEventListener('appinstalled', () => {
                console.log('اپلیکیشن با موفقیت نصب شد');
                setShowInstallPrompt(false);
            });

            return () => {
                window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
            };
        }
    }, []);

    const handleInstallClick = async () => {
        if (!deferredPrompt) return;

        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;

        if (outcome === 'accepted') {
            console.log('کاربر نصب اپلیکیشن را تایید کرد');
        }

        setDeferredPrompt(null);
        setShowInstallPrompt(false);
    };

    const closeIOSPrompt = () => {
        setIsIOSPromptVisible(false);
    };

    // رندر پیام برای دستگاه‌های غیر iOS (دکمه نصب مستقیم)
    if (showInstallPrompt) {
        return (
            <div style={styles.banner}>
                <p style={{ margin: 0 }}>برای تجربه بهتر، اپلیکیشن ما را نصب کنید!</p>
                <button onClick={handleInstallClick} style={styles.button}>
                    نصب
                </button>
            </div>
        );
    }

    // رندر راهنمای متنی برای iOS (سافاری)
    if (isIOSPromptVisible) {
        return (
            <div style={styles.iosBanner}>
                <button onClick={closeIOSPrompt} style={styles.closeBtn}>×</button>
                <p style={{ margin: '0 0 10px 0' }}>
                    برای نصب اپلیکیشن:
                    <br/>
                    ۱. دکمه <strong>اشتراک‌گذاری (Share)</strong> را در پایین مرورگر لمس کنید.
                    <br/>
                    ۲. گزینه <strong>Add to Home Screen</strong> ➕ را انتخاب کنید.
                </p>
            </div>
        );
    }

    return null;
};

const styles = {
    banner: {
        position: 'fixed',
        bottom: '20px',
        left: '20px',
        right: '20px',
        backgroundColor: '#333',
        color: '#fff',
        padding: '15px',
        borderRadius: '8px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        zIndex: 9999,
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
    },
    button: {
        padding: '8px 16px',
        backgroundColor: '#61dafb',
        color: '#000',
        border: 'none',
        borderRadius: '4px',
        fontWeight: 'bold',
        cursor: 'pointer',
    },
    iosBanner: {
        position: 'fixed',
        bottom: '20px',
        left: '20px',
        right: '20px',
        backgroundColor: '#f8f9fa',
        color: '#333',
        padding: '15px',
        borderRadius: '8px',
        border: '1px solid #ddd',
        zIndex: 9999,
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        direction: 'rtl'
    },
    closeBtn: {
        position: 'absolute',
        top: '5px',
        left: '10px',
        background: 'none',
        border: 'none',
        fontSize: '20px',
        cursor: 'pointer',
        color: '#666'
    }
};

export default InstallPrompt;